import { FC, useEffect, useState } from "react";
import "./WebLinkDetailScreen.css";
import backIcon from "../../assets/images/back-icon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import loadingGif from "../../assets/gif/app-loader.gif";

const WebLinkDetailScreen: FC = () => {
  const navigate = useNavigate();
  const { state } = useLocation() as {
    state?: { anyData?: { title: string; url: string } };
  };
  const [isLoading, setIsLoading] = useState(true);
  const [url, setUrl] = useState("");

  useEffect(() => {
    if (state?.anyData?.url) {
      setUrl(state.anyData.url);
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [state]);

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  if (!state?.anyData?.url) {
    return <div className="wms-mobile-container">No URL provided</div>;
  }

  return (
    <div className="wms-mobile-container">
      <div className="web-link-detail-screen-container">
        <div className="web-link-detail-header-container">
          <img
            src={backIcon}
            alt="dropdown-logo"
            className="image"
            onClick={handleBackButtonClick}
          />
          <div className="title">{state?.anyData?.title ?? ""}</div>
        </div>
        {isLoading && (
          <div className="web-link-detail-loader-container">
            <img
              src={loadingGif}
              alt="Loading..."
              className="web-link-detail-loader"
            />
          </div>
        )}
        <iframe
          src={url}
          title="External page"
          className="web-link-detail-url-container"
          onLoad={handleIframeLoad}
          style={{
            opacity: isLoading ? 0 : 1,
            height: isLoading ? 0 : "calc(100dvh - 77px)",
          }}
        />
      </div>
    </div>
  );
};

export default WebLinkDetailScreen;
